import { Outlet } from "react-router";

const AdminUser = () => {
	return <Outlet />;
};

export default AdminUser;
